<template>
  <b-modal v-model="isOpen" title="Signature" @hidden="closeDialog" size="lg" centered hide-footer>
    <div v-if="loading" class="loading-spinner">
      <div class="spinner"></div>
    </div>

    <img :src="signatureUrl" alt="Signature" style="width: 100%">

  </b-modal>
</template>

<script>

export default {
  name: 'SignatureModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    signatureUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:isOpen', false)
      this.$emit('close')
    },
    show() {
      this.isOpen = true
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem 0;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 0 0 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>